import React, { FC, useEffect, useState } from 'react';
import { TimerProps } from './types';
import './styles/timer.css';
import TimerImage from '../assets/images/timer.png';

export const Timer: FC<TimerProps> = ({ minutes, seconds }) => {
    const [time, setTime] = useState({ minutes, seconds });

    useEffect(() => {
        const interval = setInterval(() => {
            setTime((prevTime) => {
                const { minutes, seconds } = prevTime;

                if (seconds > 0) {
                    return { minutes, seconds: seconds - 1 };
                }

                if (seconds === 0 && minutes > 0) {
                    return { minutes: minutes - 1, seconds: 59 };
                }

                clearInterval(interval);
                return { minutes: 0, seconds: 0 }; // Timer finito
            });
        }, 1000);

        return () => clearInterval(interval); // Cleanup
    }, []);

    return (
        <div className='timer'>
            <img src={TimerImage} />
            <p>
                {String(time.minutes).padStart(2, '0')}:{String(time.seconds).padStart(2, '0')}
            </p>
        </div>
    );
};
